<template>
  <v-container fluid class="pa-0">
    <page-header-image :slider-content="slider" />
    <v-container fluid class="pa-0 bgGray">
      <v-container v-if="campaignIsActive"
                   class="bgGray py-10">
        <!--v-tabs v-model="tab"
                class="bgGray"
                fixed-tabs>
          <template v-for="(item, index) in tabContent">
            <v-tab :key="`${index}th`" class="tabFont" :class="$vuetify.breakpoint.smAndDown ? 'f18' : 'f26'">
              {{ item.tabTitle }}
            </v-tab>
          </template>
        </v-tabs-->
        <v-tabs-items v-model="tab" class="bgGray">
          <template v-for="(item, index) in tabContent">
            <v-tab-item :key="`${index}tc`" class="bgGray">
              <v-container class="py-10">
                <v-row>
                  <v-col cols="12" sm="8">
                    <div class="display-1 text-left">
                      {{ item.title }}
                    </div>
                    <div class="mt-10"
                         :style="$vuetify.breakpoint.smAndUp ? `max-width: 85%;` : ''">
                      {{ item.description }}
                    </div>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <template v-for="(partner, pindex) in item.partners">
                    <v-col cols="6" sm="3" lg="2" :key="`${pindex}pc`">
                      <v-hover v-slot="{ hover }">
                        <v-card color="#ffffff" elevation="0" min-height="280px">
                          <v-card-text>
                            <v-img :src="`${publicPath}images/logo/${partner.logo}`"
                                   aspect-ratio="1" :alt="`${partner.name}`"
                                   :title="`${partner.name}`">
                            </v-img>
                            <div class="body-1 font-weight-black text-center my-3">
                              {{ partner.name }}
                            </div>
                            <v-slide-y-reverse-transition>
                              <div v-if="hover" class="text-center">
                                <v-btn color="primary"
                                       @click="goToPartnerPage(partner)">
                                  {{ $t('button.next') }}
                                </v-btn>
                              </div>
                            </v-slide-y-reverse-transition>
                          </v-card-text>
                          <!--v-expand-transition>
                            <div v-if="hover"
                                 class="d-flex gray-overlay-darken-3 card-overlay">
                              <v-btn color="primary">
                                {{ $t('button.next') }}
                              </v-btn>
                            </div>
                          </v-expand-transition-->
                        </v-card>
                      </v-hover>
                    </v-col>
                  </template>
                </v-row>
              </v-container>
            </v-tab-item>
          </template>
        </v-tabs-items>
      </v-container >
    </v-container>
  </v-container>
</template>

<script>
import PageHeaderImage from '@/components/PageHeaderImage.vue';
import { CAMPAIGN_IS_ACTIVE, Z_IS_ACTIVE } from '@/utils/config.js';

export default {
  name: 'HomeAlternate',
  components: {
    PageHeaderImage,
  },
  beforeMount() {
    this.$store.commit('setCampaignName', null);
    this.tabContent[0].partners.sort((a, b) => a.order - b.order);
  },
  props: {
    //
  },
  data() {
    return {
      campaignIsActive: CAMPAIGN_IS_ACTIVE,
      slider: {
        id: 1001,
        root_id: null,
        code: 'slider-nyito',
        img_path: Z_IS_ACTIVE === 1 ? 'images/samsung/mainSliderPCFoldFlip2022v2.jpg' : 'images/samsung/mainSlider2022A33PCv2.jpg',
        mob_img_path: Z_IS_ACTIVE === 1 ? 'images/samsung/mainSliderMOBFoldFlip2022v2.jpg' : 'images/samsung/mainSlider2022A33MOB.jpg',
        link_url: null,
        language: 'hu',
        name: null,
        colAlign: 'start',
        textAlign: 'text-left',
        title: 'Cseréld le régi okostelefonod!',
        subtitle: 'Készülékbeszámítási promóció',
        descCashback: Z_IS_ACTIVE === 1 ? 'Számíttasd be régi készülékedet a promóció időtartama alatt! Galaxy Z Fold3 5G vásárlásod során '
          + 'felhasználható 150.000 Ft értékű, illetve Galaxy Z Flip3 5G vásárlásod során felhasználható 100.000 Ft '
          + 'értékű kupont küldünk számodra, vagy ezt az összeget hozzáadjuk a régi készüléked vételárához!' : 'Számíttasd be régi '
          + 'készülékedet a promóció időtartama alatt!',
        descVoucher: '',
        //desc: 'Váltsd be használt készülékedet nálunk, amelynek értékét a beszámítást követően megkapsz tőlünk!<br>A készülékbeszámítás kalkulációja mellé egy kódot adunk, amelyet a lent felsorolt partnereinknél tudsz beváltani. A kód beváltásával partnereink kedvezményes árat biztosítanak az új Galaxy Note 20 és Galaxy Note 20 Ultra készülékekre.',
        // <br>A készülékbeszámítás mellé egy kódot adunk, amelyet a lent felsorolt partnereinknél tudsz beváltani. A kód beváltásával partnereink kedvezményes árat biztosítanak új Galaxy S20, S20+ és S20 Ultra készülékekre.
        child: [
          /* {
            id: 1040,
            root_id: 1001,
            code: 'button-szolgaltatasok',
            img_path: null,
            link_url: 'services',
            language: 'hu',
            name: null,
            title: 'button.findOutMore',
            desc: null,
          }, */
        ],
      },
      tab: 0,
      tabContent: [
        {
          tabTitle: 'Ügyfeleink részére',
          title: Z_IS_ACTIVE === 1 ? 'Válaszd ki, melyik partnerünknél szeretnél új Galaxy Z Fold3 vagy Galaxy Z '
            + 'Flip3 készüléket vásárolni!' : 'Válaszd ki, melyik partnerünknél szeretnél új A33 készüléket vásárolni!',
          description: 'A kedvezményt különböző módon tudod érvényesíteni. Válaszd ki a kiszemelt online üzletet '
            + 'és végig vezetünk, hogy néhány egyszerű lépésben kihasználd a Samsung által kínált promóciós kedvezményt.',
          partners: [
            /*{
              name: 'Samsung webáruház',
              logo: 'samsung@400.png',
              link: 'estore-voucher',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 1,
            },*/
            /*{
              name: 'Yettel',
              logo: 'yettelKEK400.png',
              link: 'yettel-cashback',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 2,
            },*/
            /*{
              name: 'Telekom',
              logo: 'telekom.png',
              link: 'telekom-cashback',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 4,
            },*/
            /*{
              name: 'Vodafone',
              logo: 'vodafone.png',
              link: 'vodafone-cashback',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 3,
            },*/
            /*{
              name: 'Euronics',
              logo: 'euronics@400.png',
              link: 'euronics-voucher',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 2,
            },*/
            /*{
              name: 'eMAG',
              logo: 'emag4002022.png',
              link: 'emag-edigital-voucher',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 1,
            },*/
            /*{
              name: 'Alza',
              logo: 'alza@400.png',
              link: 'alza-cashback',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 3,
            },*/
            /*{
              name: 'Samsung Experience Store',
              logo: 'ses4002022.png',
              link: 'ses-voucher',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 4,
            },
            {
              name: 'Notebook.hu',
              logo: 'notebookhu@400.png',
              link: 'notebookhu-cashback',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 9,
            },
            {
              name: 'Aqua',
              logo: 'aqua@400.png',
              link: 'aqua-cashback',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 8,
            },
            {
              name: 'Firstphone',
              logo: 'firstPhone@400.png',
              link: 'firstphone-cashback',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 10,
            },
            {
              name: 'BestByte',
              logo: 'bestbyte@400.png',
              link: 'bestbyte-cashback',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 12,
            },
            {
              name: 'iPon',
              logo: 'ipon400.png',
              link: 'ipon-cashback',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 11,
            },
            {
              name: 'konzolvilág',
              logo: 'konzolvilag400.png',
              link: 'konzolvilag-cashback',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 13,
            },
            {
              name: 'Speedshop',
              logo: 'speedshop400.jpg',
              link: 'speedshop-cashback',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 14,
            },
            {
              name: 'Auchan',
              logo: 'auchan400.png',
              link: 'auchan-cashback',
              type: this.$CUSTOMER_TYPE_CONST,
              order: 15,
            },*/
          ],
        },
        /* {
          tabTitle: 'Partnereink részére',
          title: 'Lorem ipsum dolor',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras porttitor laoreet lacus, '
            + 'sit amet commodo tellus rutrum ut. Pellentesque hendrerit egestas nibh, vel commodo lorem tempus vitae.',
          partners: [
            {
              name: 'Euronics',
              logo: 'euronics@400.png',
              link: 'euronics-cashback',
              type: this.$PARTNER_TYPE_CONST,
            },
            {
              name: 'Notebook.hu',
              logo: 'notebookhu@400.png',
              link: 'notebookhu-cashback',
              type: this.$PARTNER_TYPE_CONST,
            },
            {
              name: 'Aqua',
              logo: 'aqua@400.png',
              link: 'aqua-cashback',
              type: this.$PARTNER_TYPE_CONST,
            },
            {
              name: 'Firstphone',
              logo: 'firstPhone@400.png',
              link: 'firstphone-cashback',
              type: this.$PARTNER_TYPE_CONST,
            },
            {
              name: 'Ramiris',
              logo: 'ramiris@400.png',
              link: 'ramiris-cashback',
              type: this.$PARTNER_TYPE_CONST,
            },
          ],
        }, */
      ]
    };
  },
  methods: {
    goToPartnerPage(partner) {
      this.$router.push({ name: `${partner.link}-home` });
      this.$store.commit('setPartnerType', partner.type);
    },
  },
};
</script>

<style scoped>

</style>
